/**
 * Institutional Routes
 *
 * Route definitions for the institutional module (MFH assets, sourcing, renovation).
 */

import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

const AllAssetsOverview = lazy(() => import('@/pages/institutional/AllAssetsOverview'));
const SourcingOverview = lazy(() => import('@/pages/institutional/SourcingOverview'));
const SourcingPipeline = lazy(() => import('@/pages/institutional/SourcingPipeline'));
const SourcingMapView = lazy(() => import('@/pages/institutional/SourcingMapView'));
const EligibleAssets = lazy(() => import('@/pages/institutional/EligibleAssets'));
const Transactions = lazy(() => import('@/pages/institutional/Transactions'));
const TransactionDetailLayout = lazy(() => import('@/pages/institutional/TransactionDetailLayout'));
const TransactionDetails = lazy(() => import('@/pages/institutional/TransactionDetails'));
const TransactionContacts = lazy(() => import('@/pages/institutional/TransactionContacts'));
const TransactionApprovalsLayout = lazy(() => import('@/pages/institutional/TransactionApprovalsLayout'));
const TransactionEnvelopesPage = lazy(() => import('@/pages/institutional/TransactionEnvelopesPage'));
const TransactionEnvelopeCreatePage = lazy(() => import('@/pages/institutional/TransactionEnvelopeCreatePage'));
const TransactionEnvelopeDetailPage = lazy(() => import('@/pages/institutional/TransactionEnvelopeDetailPage'));
const TransactionEnvelopeAdditionalDocumentPage = lazy(() => import('@/pages/institutional/TransactionEnvelopeAdditionalDocumentPage'));
const TransactionHistory = lazy(() => import('@/pages/institutional/TransactionHistory'));
const TransactionTasks = lazy(() => import('@/pages/institutional/TransactionTasks'));
const TransactionAcquisitionOverview = lazy(() => import('@/pages/institutional/TransactionAcquisitionOverview'));
const TransactionFinancingOverview = lazy(() => import('@/pages/institutional/TransactionFinancingOverview'));
const TransactionProcessesLayout = lazy(() => import('@/pages/institutional/TransactionProcessesLayout'));
const BuildingRenovation = lazy(() => import('@/pages/institutional/BuildingRenovation'));

export const institutionalRoutes = [
    {
        path: 'assets',
        element: <AllAssetsOverview />,
    },
    {
        path: 'sourcing/mfhs',
        element: <SourcingOverview />,
    },
    {
        path: 'sourcing/pipeline',
        element: <SourcingPipeline />,
    },
    {
        path: 'sourcing/map-view',
        element: <SourcingMapView />,
    },
    {
        path: 'sourcing/eligible-assets',
        element: <EligibleAssets />,
    },
    {
        path: 'sourcing/mfh-portfolios/:id',
        element: <TransactionDetailLayout />,
        children: [
            { index: true, element: <Navigate to="details" replace /> },
            { path: 'details', element: <TransactionDetails /> },
            { path: 'contacts', element: <TransactionContacts /> },
            {
                path: 'approvals',
                element: <TransactionApprovalsLayout />,
                children: [
                    { index: true, element: <TransactionEnvelopesPage /> },
                    { path: 'create', element: <TransactionEnvelopeCreatePage /> },
                    { path: ':envelopeId', element: <TransactionEnvelopeDetailPage /> },
                    { path: ':envelopeId/additional-document', element: <TransactionEnvelopeAdditionalDocumentPage /> },
                ],
            },
            { path: 'history', element: <TransactionHistory /> },
            { path: 'tasks', element: <TransactionTasks /> },
            { path: 'acquisition', element: <Navigate to="processes/acquisition" replace /> },
            { path: 'financing', element: <Navigate to="processes/financing" replace /> },
            {
                path: 'processes',
                element: <TransactionProcessesLayout />,
                children: [
                    { index: true, element: <Navigate to="acquisition" replace /> },
                    { path: 'acquisition', element: <TransactionAcquisitionOverview /> },
                    { path: 'financing', element: <TransactionFinancingOverview /> },
                ],
            },
        ],
    },
    {
        path: 'sourcing/mfh-portfolios',
        element: <Transactions />,
    },
    {
        path: 'renovation/mfh-buildings',
        element: <BuildingRenovation />,
    },
];
